function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed3833",
  d: "M27.2 3.375A23.827 23.827 0 1 0 51.029 27.2 23.824 23.824 0 0 0 27.2 3.375zm12.2 17.24L24.086 36h-.011a2.069 2.069 0 0 1-1.329.63 2.005 2.005 0 0 1-1.34-.653l-6.415-6.415a.456.456 0 0 1 0-.653l2.039-2.039a.443.443 0 0 1 .641 0l5.086 5.086 13.976-14.079a.452.452 0 0 1 .321-.137.416.416 0 0 1 .321.137l2 2.073a.452.452 0 0 1 .025.665z",
  transform: "translate(-3.375 -3.375)"
});

var SvgRedTickCircle = function SvgRedTickCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47.654,
    height: 47.654,
    viewBox: "0 0 47.654 47.654",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedTickCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red_tick_circle.633ea3ec.svg";
export { ForwardRef as ReactComponent };